var articles = $('.articles');
var next_url = articles.data('next-url');

$('.load-more').on('click', function() {
    $.ajax({
        url: next_url,
        type: 'GET',
        dataType: 'html',
        beforeSend: function() {
            $('.load-more').hide();
            $('.load-more-spinner').show();
        }
    }).done(function(next_page) {
        $('.load-more-spinner').hide();

        let data = $(next_page).find('.articles');
        let new_url = data.data('next-url');

        if (new_url)
            $('.load-more').show();

        next_url = new_url;
        articles.append(data.html());
    });
});